import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { useQueryLoading } from '@vue/apollo-composable';
import ImpactDashboard from '~/pdf/Impact/impact_dashboard';
import { useBasicInfoForCompanyQuery, useGetImpactGoalQuery, useGetImpactSummaryQuery, useListEvidenceLinksQuery } from '~/types/types';
import { useShowDebugging } from '~/functions/accounts';
export default /*#__PURE__*/_defineComponent({
  __name: 'ImpactGoalExport',
  props: {
    ventureId: {
      type: String,
      required: true
    }
  },
  emits: ['close'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var showDebugging = useShowDebugging();
    var chartRef = ref();
    var _useBasicInfoForCompa = useBasicInfoForCompanyQuery({
        ventureId: props.ventureId
      }),
      companyResult = _useBasicInfoForCompa.result;
    var _useGetImpactSummaryQ = useGetImpactSummaryQuery({
        ventureId: props.ventureId
      }),
      impactSummaryResult = _useGetImpactSummaryQ.result;
    var impactSummary = computed(function () {
      var _impactSummaryResult$, _impactSummaryResult$2;
      return (_impactSummaryResult$ = impactSummaryResult === null || impactSummaryResult === void 0 ? void 0 : (_impactSummaryResult$2 = impactSummaryResult.value) === null || _impactSummaryResult$2 === void 0 ? void 0 : _impactSummaryResult$2.getImpactSummary) !== null && _impactSummaryResult$ !== void 0 ? _impactSummaryResult$ : {};
    });
    var companyInfo = computed(function () {
      var _companyResult$value$, _companyResult$value;
      return (_companyResult$value$ = companyResult === null || companyResult === void 0 ? void 0 : (_companyResult$value = companyResult.value) === null || _companyResult$value === void 0 ? void 0 : _companyResult$value.basicInfoForCompany) !== null && _companyResult$value$ !== void 0 ? _companyResult$value$ : {};
    });
    var _useGetImpactGoalQuer = useGetImpactGoalQuery({
        ventureId: props.ventureId
      }),
      impactGoalResult = _useGetImpactGoalQuer.result;
    var impactGoal = computed(function () {
      var _impactGoalResult$val;
      return ((_impactGoalResult$val = impactGoalResult.value) === null || _impactGoalResult$val === void 0 ? void 0 : _impactGoalResult$val.getImpactGoal) || {};
    });
    var impactIds = computed(function () {
      var _impactGoal$value$imp, _impactGoal$value;
      return ((_impactGoal$value$imp = (_impactGoal$value = impactGoal.value) === null || _impactGoal$value === void 0 ? void 0 : _impactGoal$value.impacts) !== null && _impactGoal$value$imp !== void 0 ? _impactGoal$value$imp : []).map(function (impact) {
        return impact === null || impact === void 0 ? void 0 : impact.id;
      }).filter(function (id) {
        return typeof id === 'number';
      });
    });
    var impactSolutionIds = computed(function () {
      var _impactGoal$value$imp2, _impactGoal$value2;
      return ((_impactGoal$value$imp2 = (_impactGoal$value2 = impactGoal.value) === null || _impactGoal$value2 === void 0 ? void 0 : _impactGoal$value2.impacts) !== null && _impactGoal$value$imp2 !== void 0 ? _impactGoal$value$imp2 : []).flatMap(function (impact) {
        var _impact$impactSolutio;
        return (_impact$impactSolutio = impact === null || impact === void 0 ? void 0 : impact.impactSolutions) !== null && _impact$impactSolutio !== void 0 ? _impact$impactSolutio : [];
      }).map(function (solution) {
        return solution === null || solution === void 0 ? void 0 : solution.id;
      }).filter(function (id) {
        return typeof id === 'number';
      });
    });
    var impactEvidenceVariables = computed(function () {
      return {
        filters: {
          accountId: props.ventureId,
          entityIntIds: impactIds.value,
          type: 'impact'
        },
        limit: 1000,
        offset: 0
      };
    });
    var impactSolutionEvidenceVariables = computed(function () {
      return {
        filters: {
          accountId: props.ventureId,
          entityIntIds: impactSolutionIds.value,
          type: 'impact-solution'
        },
        limit: 1000,
        offset: 0
      };
    });
    var _useListEvidenceLinks = useListEvidenceLinksQuery(impactEvidenceVariables, computed(function () {
        return {
          enabled: impactIds.value.length > 0
        };
      })),
      impactEvidenceResult = _useListEvidenceLinks.result;
    var _useListEvidenceLinks2 = useListEvidenceLinksQuery(impactSolutionEvidenceVariables, computed(function () {
        return {
          enabled: impactSolutionIds.value.length > 0
        };
      })),
      impactSolutionEvidenceResult = _useListEvidenceLinks2.result;
    var loading = useQueryLoading();
    var metricValues = computed(function () {
      var _impactSummary$value;
      return ((_impactSummary$value = impactSummary.value) === null || _impactSummary$value === void 0 ? void 0 : _impactSummary$value.ghgMetricValues) || [];
    });
    var chartSolutionSeries = computed(function () {
      var _impactSummary$value$, _impactSummary$value2;
      return ((_impactSummary$value$ = (_impactSummary$value2 = impactSummary.value) === null || _impactSummary$value2 === void 0 ? void 0 : _impactSummary$value2.impactSolutionSummaries) !== null && _impactSummary$value$ !== void 0 ? _impactSummary$value$ : []).filter(function (summary) {
        var _summary$ghgMetricVal, _summary$ghgMetricVal2;
        return ((_summary$ghgMetricVal = (_summary$ghgMetricVal2 = summary.ghgMetricValues) === null || _summary$ghgMetricVal2 === void 0 ? void 0 : _summary$ghgMetricVal2.length) !== null && _summary$ghgMetricVal !== void 0 ? _summary$ghgMetricVal : 0) > 0;
      }).map(function (summary) {
        var _summary$impactSoluti, _summary$impactSoluti2, _summary$ghgMetricVal3;
        return {
          name: ((_summary$impactSoluti = summary.impactSolution) === null || _summary$impactSoluti === void 0 ? void 0 : (_summary$impactSoluti2 = _summary$impactSoluti.concept) === null || _summary$impactSoluti2 === void 0 ? void 0 : _summary$impactSoluti2.label) || 'Solution',
          metricValues: (_summary$ghgMetricVal3 = summary.ghgMetricValues) !== null && _summary$ghgMetricVal3 !== void 0 ? _summary$ghgMetricVal3 : []
        };
      });
    });
    function groupEvidenceByEntityId(evidenceLinks) {
      return (evidenceLinks !== null && evidenceLinks !== void 0 ? evidenceLinks : []).reduce(function (acc, evidenceLink) {
        if (!evidenceLink || evidenceLink.entityIntId == null) return acc;
        var entityId = evidenceLink.entityIntId;
        if (!acc[entityId]) acc[entityId] = [];
        acc[entityId].push(evidenceLink);
        return acc;
      }, {});
    }
    function generateReport() {
      return _generateReport.apply(this, arguments);
    }
    function _generateReport() {
      _generateReport = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _impactEvidenceResult, _impactSolutionEviden, _clonedImpactGoal$imp, _useNuxtApp$$i18n;
        var clonedImpactGoal, impactEvidenceByEntityId, impactSolutionEvidenceByEntityId, impactData, chartSvg;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              clonedImpactGoal = JSON.parse(JSON.stringify(impactGoal.value));
              impactEvidenceByEntityId = groupEvidenceByEntityId((_impactEvidenceResult = impactEvidenceResult.value) === null || _impactEvidenceResult === void 0 ? void 0 : _impactEvidenceResult.listEvidenceLinks);
              impactSolutionEvidenceByEntityId = groupEvidenceByEntityId((_impactSolutionEviden = impactSolutionEvidenceResult.value) === null || _impactSolutionEviden === void 0 ? void 0 : _impactSolutionEviden.listEvidenceLinks);
              _context3.next = 5;
              return Promise.all((clonedImpactGoal === null || clonedImpactGoal === void 0 ? void 0 : (_clonedImpactGoal$imp = clonedImpactGoal.impacts) === null || _clonedImpactGoal$imp === void 0 ? void 0 : _clonedImpactGoal$imp.map(/*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(impact) {
                  var sdgsWithDataURL;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return Promise.all(impact.sdgs.map(/*#__PURE__*/function () {
                          var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(sdg) {
                            var dataURL;
                            return regeneratorRuntime.wrap(function _callee$(_context) {
                              while (1) switch (_context.prev = _context.next) {
                                case 0:
                                  _context.next = 2;
                                  return toDataUrl(require("../../assets/img/sdgs/".concat(sdg.id, ".png")));
                                case 2:
                                  dataURL = _context.sent;
                                  return _context.abrupt("return", _objectSpread(_objectSpread({}, sdg), {}, {
                                    dataURL: dataURL
                                  }));
                                case 4:
                                case "end":
                                  return _context.stop();
                              }
                            }, _callee);
                          }));
                          return function (_x2) {
                            return _ref3.apply(this, arguments);
                          };
                        }()));
                      case 2:
                        sdgsWithDataURL = _context2.sent;
                        return _context2.abrupt("return", _objectSpread(_objectSpread({}, impact), {}, {
                          sdgs: sdgsWithDataURL,
                          evidenceLinks: impactEvidenceByEntityId[impact.id] || [],
                          impactSolutions: (impact.impactSolutions || []).map(function (solution) {
                            return _objectSpread(_objectSpread({}, solution), {}, {
                              evidenceLinks: impactSolutionEvidenceByEntityId[solution.id] || []
                            });
                          })
                        }));
                      case 4:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref2.apply(this, arguments);
                };
              }())) || []);
            case 5:
              impactData = _context3.sent;
              // Capture chart SVG
              chartSvg = null;
              if (!chartRef.value) {
                _context3.next = 23;
                break;
              }
              _context3.next = 10;
              return nextTick();
            case 10:
              _context3.next = 12;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 100);
              });
            case 12:
              _context3.prev = 12;
              _context3.next = 15;
              return chartRef.value.getSvgData();
            case 15:
              chartSvg = _context3.sent;
              _context3.next = 21;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](12);
              console.error('Error capturing SVG:', _context3.t0);
            case 21:
              _context3.next = 24;
              break;
            case 23:
              console.log('Chart ref is null or undefined');
            case 24:
              // eslint-disable-next-line no-new
              new ImpactDashboard(_objectSpread(_objectSpread({}, clonedImpactGoal), {}, {
                impacts: impactData
              }), companyInfo.value, impactSummary.value, (_useNuxtApp$$i18n = useNuxtApp().$i18n) === null || _useNuxtApp$$i18n === void 0 ? void 0 : _useNuxtApp$$i18n.locale, chartSvg);
              emit('close');
            case 26:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[12, 18]]);
      }));
      return _generateReport.apply(this, arguments);
    }
    function toDataUrl(url) {
      return new Promise(function (resolve) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
          var reader = new FileReader();
          reader.onloadend = function () {
            resolve(reader.result);
          };
          reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
      });
    }
    return {
      __sfc: true,
      props: props,
      showDebugging: showDebugging,
      emit: emit,
      chartRef: chartRef,
      companyResult: companyResult,
      impactSummaryResult: impactSummaryResult,
      impactSummary: impactSummary,
      companyInfo: companyInfo,
      impactGoalResult: impactGoalResult,
      impactGoal: impactGoal,
      impactIds: impactIds,
      impactSolutionIds: impactSolutionIds,
      impactEvidenceVariables: impactEvidenceVariables,
      impactSolutionEvidenceVariables: impactSolutionEvidenceVariables,
      impactEvidenceResult: impactEvidenceResult,
      impactSolutionEvidenceResult: impactSolutionEvidenceResult,
      loading: loading,
      metricValues: metricValues,
      chartSolutionSeries: chartSolutionSeries,
      groupEvidenceByEntityId: groupEvidenceByEntityId,
      generateReport: generateReport,
      toDataUrl: toDataUrl
    };
  }
});